exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-wrapper {\n    height: 350px;\n}\n\n:host ::ng-deep .flutter-app {\n    height: 100% !important;\n    width: 100% !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/feedback/feedback.component.css
// module id = ../../../../../src/app/layout/home/feedback/feedback.component.css
// module chunks = main